(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsReverseOsmosisViewModel', facilityDetailsReverseOsmosisViewModelFactory);

  /** @ngInject */
  function facilityDetailsReverseOsmosisViewModelFactory(reverseOsmosisSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsReverseOsmosisViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);

      this._propertyMappings = {};
      this._propertyMappings[reverseOsmosisSubsystemUtils.FeedReferences.OP_TLAK_REV_OSMOZA] = 'lps';
      this._propertyMappings[reverseOsmosisSubsystemUtils.FeedReferences.OP_FWV_REV_OSMOZA] = 'fwy';
      this._propertyMappings[reverseOsmosisSubsystemUtils.FeedReferences.OP_CRP_REV_OSMOZA_U_RADU] = 'motor';
      this._propertyMappings[reverseOsmosisSubsystemUtils.FeedReferences.OP_CRPKA_REV_OSMOZA_GRE_MZS] = 'motorError';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(reverseOsmosisSubsystemUtils.getReverseOsmosisSubsystemPoint(facilityPointJson));
      }
    }

    FacilityDetailsReverseOsmosisViewModel.prototype.destroy = function () {

    };

    FacilityDetailsReverseOsmosisViewModel.prototype.refresh = function (reverseOsmosisPointJson) {
      this.pointId = reverseOsmosisPointJson.id;
      this.name = reverseOsmosisPointJson.name;
      this.pointType = reverseOsmosisPointJson.pointType;
      setFeedValue.call(this, reverseOsmosisSubsystemUtils.getFeed(reverseOsmosisPointJson, reverseOsmosisSubsystemUtils.FeedReferences.OP_TLAK_REV_OSMOZA));
      setFeedValue.call(this, reverseOsmosisSubsystemUtils.getFeed(reverseOsmosisPointJson, reverseOsmosisSubsystemUtils.FeedReferences.OP_FWV_REV_OSMOZA));
      setFeedValue.call(this, reverseOsmosisSubsystemUtils.getFeed(reverseOsmosisPointJson, reverseOsmosisSubsystemUtils.FeedReferences.OP_CRP_REV_OSMOZA_U_RADU));
      setFeedValue.call(this, reverseOsmosisSubsystemUtils.getFeed(reverseOsmosisPointJson, reverseOsmosisSubsystemUtils.FeedReferences.OP_CRPKA_REV_OSMOZA_GRE_MZS));
    };

    FacilityDetailsReverseOsmosisViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsReverseOsmosisViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();
